/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApAdListResponseApiFrom } from '../../models/ap-ad-list-response-api-from';

export interface ApiV3ServiceApAdListGet$Plain$Params {

/**
 * language code
 */
  lang?: string;
}

export function apiV3ServiceApAdListGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV3ServiceApAdListGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApAdListResponseApiFrom>>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceApAdListGet$Plain.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ApAdListResponseApiFrom>>;
    })
  );
}

apiV3ServiceApAdListGet$Plain.PATH = '/api/v3/service/ApAdList';
